// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".campaign-select {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-top: 2em;\n}\n.campaign-select h4 {\n  margin: 0px;\n  margin-right: 1em;\n}\n.campaign-select .dropdown {\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n.campaign-select .dropdown > button {\n  border-radius: 6px;\n}", ""]);
// Exports
module.exports = exports;
